<template>
  <div>
    <BillingDialCampaign v-if="getShowBillingCampaign" />
    <CommercialDialCampaign v-if="getShowCommercialCampaign" />
    <ImplantacaoDialCampaign v-if="getShowImplantacaoCampaign" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BillingDialCampaign from "./BillingDialCampaign.vue";
import CommercialDialCampaign from "./CommercialDialCampaign.vue";
import ImplantacaoDialCampaign from "./ImplantacaoDialCampaign.vue";

export default {
  name: "DialCampaign",
  components: {
    BillingDialCampaign,
    CommercialDialCampaign,
    ImplantacaoDialCampaign,
  },
  methods: {
    displayAppWelcomeHome(display = false) {
      const divWelcome = document.getElementById("welcome-home-screen");
      if (divWelcome) {
        divWelcome.style.display = display ? "flex" : "none";
      }
    },
  },
  computed: {
    ...mapGetters(["getShowBillingCampaign", "getShowCommercialCampaign", "getShowImplantacaoCampaign"]),
  },
  watch: {
    getShowBillingCampaign(value) {
      this.displayAppWelcomeHome(!value);
    },
    getShowCommercialCampaign(value) {
      this.displayAppWelcomeHome(!value);
    },
    getShowImplantacaoCampaign(value) {
      this.displayAppWelcomeHome(!value);
    },
  }
};
</script>